import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'

export const StyledReportAdverseEvent = styled.div({
  padding: ClinTheme.space[4],
  border: '1px solid ' + ClinTheme.colors.grey,
  borderRadius: ClinTheme.radii[2]
})
